import { Box, IconButton, TableCell, TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";
import TalentIntroductionStatus from "../TalentIntroductionStatus";
import { TalentIntroductionRow } from "../../../types";
import ChipList from "../../../../../../common/components/functional/chipList/ChipList";
import { ChipListProps } from "../../../../../../common/components/functional/chipList/types";
import { NameIdOption } from "../../../../../../common/types/commonTypes";
import { MoreVert as MoreIcon } from "@mui/icons-material";
import { format } from "date-fns";
import { leadingZerosDateFormat } from "../../../../../../common/helpers/formatDateTime";
import InfoTooltip from "../../../../../../common/components/functional/InfoTooltip/InfoTooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

type Props = {
  index: number;
  row: TalentIntroductionRow;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  withOrder?: boolean;
};

const TalentIntroductionsToCustomerTableRow = ({
  index,
  row,
  onClick,
  withOrder,
}: Props) => {
  const { t } = useTranslation("talentProfile");
  const chipListProps: ChipListProps<NameIdOption> = {
    list: row.workTitles,
    idKey: "id",
    labelKey: "name",
    emptyState: "",
  };
  return (
    <TableRow key={row.introducedAt}>
      <TableCell size="small">
        <Box display="flex" alignItems="center" gap="4px">
          {format(new Date(row.introducedAt), leadingZerosDateFormat)}
          {withOrder && (
            <InfoTooltip
              title={t("profileSummary.orderIntroductionDateTooltip")}
              icon={<InfoOutlinedIcon sx={{ height: "16px", width: "16px" }} />}
            />
          )}
        </Box>
      </TableCell>
      <TableCell size="small">{row.customerOrgName}</TableCell>
      <TableCell size="small">{row.workLocationName}</TableCell>
      <TableCell size="small">
        {<ChipList size="small" {...chipListProps} />}
      </TableCell>
      <TableCell size="small" align="right">
        <TalentIntroductionStatus status={row.status} withOrder={withOrder} />
      </TableCell>
      {onClick && (
        <TableCell padding="checkbox" size="small" align="right" width="50px">
          <IconButton
            id={index.toString()}
            size="small"
            sx={{ marginTop: "-2px" }}
            onClick={onClick}
          >
            <MoreIcon sx={{ width: "18px", height: "18px" }} />
          </IconButton>
        </TableCell>
      )}
    </TableRow>
  );
};

export default TalentIntroductionsToCustomerTableRow;
